import React, { CSSProperties, FC, useEffect, useMemo, useRef } from "react";

import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import ButtonSpinner from "newComponents/Shared/_Atoms/Spinner/ButtonSpinner/ButtonSpinner";
import { genClasses } from "utils/textHelpers";

export interface IButtonProps {
  name: string;
  onClick: (event: any) => void;
  disabled?: boolean;
  icon?: IconType;
  centered?: boolean;
  primary?: boolean;
  iconStyle?: CSSProperties;
  grey?: boolean;
  pulse?: boolean;
  blue?: boolean;
  fixedWidth?: boolean;
  style?: CSSProperties;
  className?: string;
  isLoading?: boolean;
  id?: string;
  loaderColor?: string;
  focus?: boolean;
}

interface IClassObject {
  [key: string]: string;
}

const Button: FC<IButtonProps> = ({
  name,
  onClick,
  disabled,
  icon,
  centered,
  primary,
  iconStyle,
  grey,
  pulse,
  blue,
  fixedWidth,
  style,
  className,
  isLoading,
  id,
  loaderColor,
  focus
}) => {
  const color = useMemo((): IClassObject => {
    const arr = [];
    primary && arr.push("primary");
    grey && arr.push("button-grey");

    !primary && !grey && arr.push("std");

    return { [arr[0]]: arr[0] };
  }, [primary, grey]);

  const buttonRef = useRef(null);
  useEffect(() => {
    if (focus) {
      buttonRef.current.focus();
    } else {
      buttonRef.current.blur();
    }
  }, [focus]);

  const handleClick = (event) => !disabled && !isLoading && onClick(event);

  return (
    <button
      className={genClasses("button", {
        pulse: pulse,
        "centered-button": centered,
        blue: blue,
        "fixed-width": fixedWidth,
        disabled: disabled,
        "with-icon": icon && !isLoading,
        className,
        ...color
      })}
      onClick={handleClick}
      disabled={disabled}
      style={style}
      id={id}
      data-tid={id}
      ref={buttonRef}
    >
      {icon && !isLoading && <Icon className="button-icon" icon={icon} style={iconStyle} />}
      {isLoading && <ButtonSpinner color={loaderColor} />}
      <span dangerouslySetInnerHTML={{ __html: name }} />
    </button>
  );
};

export default Button;
